import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.access/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.access-shell {
  --access-bg: #f3efe7;
  --access-panel: rgba(252, 250, 246, 0.88);
  --access-border: rgba(83, 64, 34, 0.14);
  --access-text: #1e1a15;
  --access-muted: #6f6256;
  --access-primary: #9f3d22;
  --access-primary-strong: #7b2d16;
  --access-highlight: #d3b17a;
  position: relative;
  min-height: 100vh;
  overflow: hidden;
  background: radial-gradient(circle at top left, rgba(211, 177, 122, 0.55), transparent 34%), radial-gradient(circle at right 12% bottom 20%, rgba(159, 61, 34, 0.16), transparent 28%), linear-gradient(135deg, #f7f3eb 0%, #ebe0d2 45%, #e1d4c2 100%);
}

.access-ambient {
  position: absolute;
  border-radius: 999px;
  filter: blur(6px);
  opacity: 0.5;
}

.access-ambient-left {
  top: -8rem;
  left: -6rem;
  width: 18rem;
  height: 18rem;
  background: rgba(159, 61, 34, 0.18);
}

.access-ambient-right {
  right: -4rem;
  bottom: -5rem;
  width: 16rem;
  height: 16rem;
  background: rgba(211, 177, 122, 0.34);
}

.access-stage {
  position: relative;
  z-index: 1;
  min-height: 100vh;
  display: grid;
  grid-template-columns: minmax(0, 1.2fr) minmax(22rem, 28rem);
  gap: 2rem;
  align-items: center;
  padding: 2rem;
}

.access-story {
  max-width: 42rem;
  padding: 2rem;
}

.access-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.8rem;
  border: 1px solid var(--access-border);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.34);
  color: var(--access-muted);
  font-size: 12px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.access-badge-dot {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 999px;
  background: var(--access-primary);
  box-shadow: 0 0 0 6px rgba(159, 61, 34, 0.12);
}

.access-title {
  margin: 1.4rem 0 0;
  color: var(--access-text);
  font-size: clamp(2.8rem, 6vw, 5.4rem);
  line-height: 0.94;
  font-weight: 800;
  letter-spacing: -0.06em;
}

.access-subtitle {
  max-width: 34rem;
  margin: 1.2rem 0 0;
  color: var(--access-muted);
  font-size: 15px;
  line-height: 1.8;
}

.access-panel-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.9rem;
  margin-top: 2rem;
}

.access-metric {
  padding: 1rem;
  border: 1px solid var(--access-border);
  border-radius: 1.2rem;
  background: rgba(255, 255, 255, 0.38);
  backdrop-filter: blur(10px);
}

.access-metric-label {
  display: block;
  color: var(--access-muted);
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.access-metric-value {
  display: block;
  margin-top: 0.5rem;
  color: var(--access-text);
  font-size: 15px;
  font-weight: 700;
}

.access-card {
  position: relative;
  padding: 1.6rem;
  border: 1px solid rgba(83, 64, 34, 0.18);
  border-radius: 1.8rem;
  background: var(--access-panel);
  backdrop-filter: blur(18px);
  box-shadow: 0 20px 60px rgba(74, 52, 24, 0.14);
}

.access-card-head {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.access-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 1rem;
  background: linear-gradient(135deg, var(--access-primary), var(--access-highlight));
  color: white;
  font-size: 1.1rem;
  font-weight: 800;
}

.access-eyebrow {
  margin: 0;
  color: var(--access-muted);
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.access-heading {
  margin: 0.3rem 0 0;
  color: var(--access-text);
  font-size: 1.5rem;
  font-weight: 700;
}

.access-fieldset {
  margin-top: 1rem;
}

.access-label {
  display: block;
  margin-bottom: 0.45rem;
  color: var(--access-text);
  font-size: 13px;
  font-weight: 600;
}

.access-input {
  width: 100%;
  padding: 0.95rem 1rem;
  border: 1px solid rgba(83, 64, 34, 0.16);
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.8);
  color: var(--access-text);
  font-size: 14px;
  outline: none;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.access-input:focus {
  border-color: rgba(159, 61, 34, 0.46);
  box-shadow: 0 0 0 4px rgba(159, 61, 34, 0.12);
  transform: translateY(-1px);
}

.access-submit {
  width: 100%;
  margin-top: 1.4rem;
  padding: 1rem 1.1rem;
  border: 0;
  border-radius: 1rem;
  background: linear-gradient(135deg, var(--access-primary) 0%, var(--access-primary-strong) 100%);
  color: white;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.02em;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, opacity 160ms ease;
  box-shadow: 0 16px 32px rgba(123, 45, 22, 0.24);
}

.access-submit:hover:not(:disabled) {
  transform: translateY(-1px);
}

.access-submit:disabled {
  opacity: 0.6;
  cursor: wait;
}

.access-note {
  margin-top: 1rem;
  padding: 1rem 1.05rem;
  border-radius: 1rem;
  background: rgba(210, 188, 150, 0.18);
  border: 1px solid rgba(159, 61, 34, 0.1);
}

.access-note-title {
  margin: 0;
  color: var(--access-text);
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.access-note-body {
  margin: 0.45rem 0 0;
  color: var(--access-muted);
  font-size: 13px;
  line-height: 1.7;
}

@media (max-width: 960px) {
  .access-stage {
    grid-template-columns: 1fr;
    padding: 1.25rem;
  }
  .access-story {
    padding: 1rem 0.3rem 0;
  }
  .access-panel-grid {
    grid-template-columns: 1fr;
  }
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public data: any = {
        username: '',
        password: ''
    };

    public submitting: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/kiera";
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: this.translate.instant('common.ok'),
            status: status
        });
    }

    public async login() {
        if (this.submitting) return;

        let user = JSON.parse(JSON.stringify(this.data));
        if (!user.username) {
            await this.alert(this.translate.instant('page.access.error_username_required'));
            return;
        }
        if (!user.password) {
            await this.alert(this.translate.instant('page.access.error_password_required'));
            return;
        }

        this.submitting = true;
        await this.service.render();

        let { code, data } = await wiz.call("login", user);

        this.submitting = false;

        if (code == 200) {
            location.href = "/kiera";
            await this.service.render();
        } else {
            await this.alert(data.message || this.translate.instant('page.access.login_failed'), 'error');
            await this.service.render();
        }
    }
}

export default PageAccessComponent;
